import React from "react";
import Grid from "@mui/material/Grid";
import tree from "../images/tree.png";
import Typography from "@mui/material/Typography";
import { Button, Card, CircularProgress, Divider } from "@mui/material";
import { Box } from "@mui/system";
import { ChevronRightRounded } from "@mui/icons-material";
import CardContent from "@mui/material/CardContent";
import axios from "axios";
import { getURLBase } from "../utils/helperFns";
import {Link} from "react-router-dom";
class MaxYouCanSave extends React.Component {
  constructor(props) {
    super(props);
    this.url = getURLBase(true) + "/carbonfootprint";
    this.state = {
      isReady: false,
    }
  }

  componentDidMount() {
    if (!this.state.isReady) {
      axios.post(this.url, { gid: this.props.gid }).then(
        (response) => { this.setState({ isReady: true, spent: response.data.body.spent, trees: response.data.body.trees }); },
      )}
  }
  render = () => {
    const WidgetData = () => (
      <Card
        className={"widgetCard cardShadow "}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
        elevation={2}
      >
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 700 }} align="center">
            Your Carbon Footprint
          </Typography>
          <Typography
            variant="subtitle1"
            color="text.secondary"
            fontWeight="600"
            align="center"
            gutterBottom
          >
            from spending this month
          </Typography>

          <Divider light />
          {this.state.isReady ? (
            
          <CardContent textAlign="center" sx={{ marginTop: "30px" }} className={`${this.state.isReady ? (`${(this.state.spent === null || this.state.spent === 0) ? "blur": "" }`) : ""  }`}>
            <Grid container spacing={1} alignItems="center">
              <Grid item xs={4}>
                <br />
                <br />
                <Typography variant="h4" textAlign="center">
                  <span style={{ fontSize: "1.8rem", fontWeight: 700 }}>{this.state.spent}</span>
                   {" "}
                   <span style={{ fontSize: "0.9rem", fontWeight: 700 }}>CO<sub>2</sub></span>
                </Typography>
                <Typography
                  variant="subtitle2"
                  color="text.secondary"
                  fontWeight="600"
                  align="center"
                  width={"120%"}
                  gutterBottom
                >
                  monthly avg. 875 Kg
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography
                  variant="body2"
                  color="text.disabled"
                  align="center"
                  fontWeight="600"
                  marginTop="25px"
                >
                  absorbed by
                </Typography>
              </Grid>
              <Grid item xs={4} justifyContent="center" sx={{ display: "flex", alignItems: "center" }}>
                <Typography variant="h4" display="block" align="center" sx={{ fontSize: "1.8rem", fontWeight: 700, minWidth: "4rem", marginTop: "25px" }}>
                  {this.state.trees}{" "}x
                </Typography>
                <Box textAlign="center">
                  <img
                    alt="tree"
                    height="80px"
                    width="80px"
                    src={tree}
                    style={{ display: "block" }}
                    ml={1}
                  />
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    mx={"auto"}
                  >
                    per year
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </CardContent>
          ) : (
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "20vh" }}>
           <CircularProgress color="success" />
         </Box>
          )}
        </Box>
        <Box className={`${this.state.isReady ? (`${(this.state.spent === null || this.state.spent === 0) ? "blur": "" }`) : ""  }`}>
          <Box textAlign="center" mt={2}>
            <Button
            component={Link}
              variant="outlined"
              fontWeight="700"
              endIcon={<ChevronRightRounded colorprimary />}
              to={`${this.state.spent === null || this.state.spent === 0 ? "/home" : "/carbon-footprint" }`}
            >
              See Details
            </Button>
          </Box>
        </Box>
      </Card>
    );

    return <WidgetData />;
  };
}

export default MaxYouCanSave;
